import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import AgriOrder from '@/models/AgriOrder.js'

export const useAgriOrderStore = defineStore('agriOrderStore', () => {
  let syncableModel = useSyncableModel(useApiResource('agri_orders'), {
    className: AgriOrder.modelName.name,
    paramKey: AgriOrder.modelName.paramKey
  })

  function findByUuid(uuid) {
    return syncableModel.collection.value.find((item) => item.uuid == uuid)
  }

  async function confirmDelivery(uuid) {
    const data = await syncableModel.resource.post(uuid, {
      agri_order_status: "delivered"
    })
    return data
  }

  async function generatePassCode(uuid, paymentMethod) {
    return await syncableModel.resource.post(`${uuid}/generate_pass_code`, { 
      payment_method: paymentMethod 
    })
  }

  async function cancelOrder(uuid) {
    const data = await syncableModel.resource.post(uuid, {
      agri_order_status: "cancelled"
    })
    return data
  }

  async function validatePassCode(uuid, pass_code) {
    return await syncableModel.resource.post(`${uuid}/validate_pass_code`, { pass_code: pass_code })
  }

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    findByUuid,
    confirmDelivery,
    cancelOrder,
    generatePassCode,
    validatePassCode,
    $reset
  }

},{
  persist: true
})